import classes from '@/components/Shares/Table.module.css';
import { useLingui } from '@lingui/react';
import { Box, Paper, Table } from '@mantine/core';
import { WalletBalance } from './WalletBalance';
import { WalletTableRow } from './WalletTableRow';
import { wallets } from './wallets';
export const WalletTabTable: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const rows = wallets.map(row => <WalletTableRow key={row.id} {...row} />);
  const ths = <Table.Tr>
      <Table.Th fz={{
      base: 10,
      md: 12
    }} w={{
      md: 200
    }}>
        {i18n._('CURRENCY')}
      </Table.Th>
      <Table.Th fz={{
      base: 10,
      md: 12
    }}>{i18n._('BALANCE')}</Table.Th>
      <Table.Th fz={{
      base: 10,
      md: 12
    }}>{i18n._('EST. VALUE')}</Table.Th>
      <Table.Th visibleFrom="sm">{''}</Table.Th>
      <Table.Th visibleFrom="sm">{''}</Table.Th>
    </Table.Tr>;
  return <Paper radius={5} p={20} bg="var(--bg-600)">
      <WalletBalance balance={1245600} pnl={54.33} />

      <Box mah={200} className={classes.scroll} mt={40}>
        <Table.ScrollContainer minWidth={300}>
          <Table striped classNames={classes}>
            <Table.Thead>{ths}</Table.Thead>
            <Table.Tbody>{rows}</Table.Tbody>
          </Table>
        </Table.ScrollContainer>
      </Box>
    </Paper>;
};